<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{'stores_status' | translate}}</h3>
          </div>
          <div class="box-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>{{'store_information' | translate | capitalize}}</th>
                    <th>{{'status_list' | translate | capitalize}}</th>
                    <th>{{'click-and-collect' | translate | capitalize}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in stores">
                    <td>
                      {{item.name}}, {{item.str_address_street}} {{item.str_address_street_number}}, {{item.str_address_zip_code}} {{item.str_address_city}}<br />
                      <small class="text-muted">{{'store_number' | translate}}: {{item.store_number}}</small>
                    </td>
                    <td>
                      <template v-for="(is_active,name) in item.channels">
                        <template v-if="name !== 'click_and_collect'">
                          <span v-if="is_active === true" class="text-success mr-5">
                            <i class="fa fa-check-square mr-5"></i>
                            <img v-if="name === 'schuhe_de'" src="/static/img/schuhede.svg" class="img-channel mr-5"/>
                            <img v-else :src="`/static/img/schuhede-${name}.svg`" class="img-channel mr-5">
                          </span>
                          <span v-else class="disabled text-danger mr-5">
                            <i class="fa fa-ban mr-5"></i>
                            <img v-if="name === 'schuhe_de'" src="/static/img/schuhede.svg" class="img-channel mr-5"/>
                            <img v-else :src="`/static/img/schuhede-${name}.svg`" class="img-channel mr-5">
                          </span>
                        </span>
                        </template>
                      </template>
                    </td>
                    <td>
                      <span v-if="item.channels.click_and_collect === true" class="text-success">
                        <i class="fa fa-check-square mr-5"></i>
                        <strong>{{'is_active' | translate}}</strong>
                      </span>
                      <span v-else class="text-danger">
                        <i class="fa fa-ban mr-5"></i>
                        <strong>{{'inactive' | translate}}</strong>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'StoreStatus',
  data () {
    return {
      count: 25,
      stores: {},
      marketplaces: {}
    }
  },
  methods: {
  },
  mounted () {
    this.$nextTick(function () {
      if (this.$store.dispatch('checkPermissions', 'co_accounting')) {
        API.get('/accounting/stores/status')
          .then(response => {
            this.stores = response.data
          }, error => {
            this.$store.dispatch('checkError', error)
            let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
            this.$store.commit('pushAlert', alert)
          })
      } else {
        this.$router.push('/unauthorized')
      }
    })
  }
}
</script>

<style scoped>
  .mp_false {
    color: #DB321B !important
  }
  .mp_true {
    color: #00C396 !important
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/StoreStatus.vue